
import React from "react"
import { useDispatchPage } from "../helpers";
import PageLoader from "@vromo/ui/components/PageLoader";
import { observer } from "mobx-react-lite";


export const PageDecorations = observer(() => {

    const { isLoading } = useDispatchPage()

    return <PageLoader loading={isLoading} />


})